module.exports = __webpack_public_path__ + "static/media/horiz-logo-white.c7ed3375.png";